import React from "react";
import TopBar from "../components/TopBar";
import { Card, Empty } from "../components/ui";
import { ShoppingBag } from "lucide-react";

export default function StorePage() {
  return (
    <div className="pb-28">
      <TopBar title="Store" subtitle="Merchandise" />
      <div className="px-5">
        <Card className="p-0">
          <Empty
            icon={ShoppingBag}
            title="Store is coming soon"
            subtitle="Jerseys, caps, food coupons — order & pay from the app. Stay tuned."
          />
        </Card>
      </div>
    </div>
  );
}
